import { WardManagementScreen } from "~/admin/ward-management-screen";
import { useAuth } from "~/auth/auth-context";
import NotFoundRoute from "~/routes/not-found";

// /admin/wards — super-admin ward management (V2-E1.2). Ward CRUD is super-admin
// only, so a non-super-admin (even a ward admin who can see the Admin nav entry)
// gets the 404 page rather than a forbidden screen. `isSuperAdmin` is already
// resolved by the time <ProtectedRoute> stops showing its spinner (the auth
// context awaits /auth/me before clearing isLoading), so there's no flash of 404.
export default function AdminWardsRoute(): JSX.Element {
  const { isSuperAdmin } = useAuth();
  if (!isSuperAdmin) return <NotFoundRoute />;
  return <WardManagementScreen />;
}
